import React from 'react';
import { Form, Input, Row, Col, Divider } from 'antd';

export const ContactsSettings: React.FC = () => {
  return (
    <>
      <Divider orientation="left">Телефоны и Email</Divider>
      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item
            label="Телефон для заказов"
            name="order_phone"
            rules={[{ pattern: /^\+?\d{10,15}$/, message: 'Неверный формат' }]}
          >
            <Input placeholder="+7 (XXX) XXX-XX-XX" />
          </Form.Item>
        </Col>
        
        <Col xs={24} md={8}>
          <Form.Item
            label="Контактный телефон"
            name="contact_phone"
            rules={[{ pattern: /^\+?\d{10,15}$/, message: 'Неверный формат' }]}
          >
            <Input placeholder="+7 (XXX) XXX-XX-XX" />
          </Form.Item>
        </Col>
        
        <Col xs={24} md={8}>
          <Form.Item
            label="Email"
            name="contact_email"
            rules={[{ type: 'email', message: 'Неверный email' }]}
          >
            <Input placeholder="info@domchef.kz" />
          </Form.Item>
        </Col>
      </Row>

      <Divider orientation="left">Социальные сети</Divider>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Facebook"
            name="facebook_url"
            rules={[{ type: 'url', message: 'Неверный URL' }]}
          >
            <Input placeholder="https://facebook.com/domchefkz" />
          </Form.Item>
        </Col>
        
        <Col xs={24} md={12}>
          <Form.Item
            label="Instagram"
            name="instagram_url"
            rules={[{ type: 'url', message: 'Неверный URL' }]}
          >
            <Input placeholder="https://instagram.com/domchefkz" />
          </Form.Item>
        </Col>
        
        <Col xs={24} md={12}>
          <Form.Item
            label="Threads"
            name="threads_url"
            rules={[{ type: 'url', message: 'Неверный URL' }]}
          >
            <Input placeholder="https://threads.net/@domchefkz" />
          </Form.Item>
        </Col>
        
        <Col xs={24} md={12}>
          <Form.Item
            label="TikTok"
            name="tiktok_url"
            rules={[{ type: 'url', message: 'Неверный URL' }]}
          >
            <Input placeholder="https://tiktok.com/@domchefkz" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};